// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1hscY","content":"styles_content__9xQZW","checkbox":"styles_checkbox__2s6-W","checkboxLabel":"styles_checkboxLabel__2_Bgc"};